import { createTheme } from '@mui/material/styles';

const DEFAULTS = {
  primaryColor: '#1f4e79',
  secondaryColor: '#00a3a1',
  fontFamily: 'Montserrat, sans-serif',
};

export function createBrandTheme(config) {
  const primary = config?.primaryColor || DEFAULTS.primaryColor;
  const secondary = config?.secondaryColor || DEFAULTS.secondaryColor;
  const fontFamily = config?.fontFamily || DEFAULTS.fontFamily;

  return createTheme({
    palette: {
      primary: { main: primary },
      secondary: { main: secondary },
    },
    typography: { fontFamily },
    components: {
      MuiTypography: {
        styleOverrides: {
          root: {
            fontFamily,
            '& strong': { fontWeight: 'bold' },
            '& em': { fontStyle: 'italic' },
            '& a': {
              color: secondary,
              textDecoration: 'none',
              '&:hover': { textDecoration: 'underline' },
            },
            '& p': { marginTop: 0, marginBottom: '0.5em' },
            '& ul': { marginTop: 0, marginBottom: '0.5em', paddingLeft: '1.5em' },
            '& li': { marginBottom: '0.25em' },
            '& h1, & h2, & h3, & h4, & h5, & h6': {
              marginTop: '0.5em',
              marginBottom: '0.25em',
            },
          },
        },
      },
      MuiTextField: {
        styleOverrides: {
          root: { fontFamily },
        },
      },
    },
  });
}

const theme = createBrandTheme();
export default theme;
